<template>
  <!-- Due to CSS limitations in transitioning gradient colors, we will use a
  workaround by transition an ::after elements opacity with the target gradient. -->

  <button
    v-if="file"
    class="gradient-transition-effect group relative z-10 flex w-fit items-center overflow-hidden rounded-sm bg-gradient-to-tr px-5 py-2 text-left text-base font-medium text-blue-800 after:bg-gradient-to-tr sm:py-3"
    :disabled="disabled || isLoading"
    :class="[
      {
        'from-blue-100/50 to-blue-100/20  after:from-blue-100/60 after:to-blue-100/30':
          isSecondary,
        'from-blue-800 to-blue-500 text-white after:from-blue-dark after:to-blue-500':
          isBlue,
        'bg-white after:from-blue-100/50 after:to-blue-50/50':
          !isSecondary && !isBlue,
      },
      disabled
        ? 'cursor-default !from-[#95a5a6] !to-[#95a5a6] after:!from-[#95a5a6] after:!to-[#95a5a6]'
        : '',
    ]"
    :aria-label="`${$t('accessibility.download_file')} ${
      fileNameFromFile || fileName
    }.${props.file?.extension}`"
    @click="downloadFile"
  >
    <!-- LINK ICON -->
    <DocumentIcon class="mr-3 w-3 shrink-0 sm:w-3.5" />

    <slot />

    <!-- SPINNER ICON -->
    <div class="transition-[width]" :class="isLoading ? 'w-8' : 'w-0'">
      <transition name="fade">
        <div v-if="isLoading">
          <SpinIcon class="ml-4 size-4 animate-spin text-blue-100 sm:size-5" />
        </div>
      </transition>
    </div>
  </button>
</template>

<script setup>
const props = defineProps({
  isSecondary: { type: Boolean, default: false },
  isBlue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  file: { type: Object, default: null },
  fileName: { type: String, default: null },
})

const isLoading = ref(false)

const fileNameFromFile = computed(() => {
  if (!props.file?.id) {
    return ''
  }

  let title = props.file.id
  const prefix = props.file.container.handle

  // replace prefix with empty string
  title = title.replace(`${prefix}::`, '')

  // replace file extension with empty string
  title = title.replace(`.${props.file.extension}`, '')

  // remove the folder structure
  title = title.match(/[^\/]*$/)[0]

  return title
})

const downloadFile = () => {
  if (!props.file?.url) {
    console.error('No file url found')
    return
  }

  isLoading.value = true

  fetch(props.file?.url)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${props.fileName || fileNameFromFile.value}.${
        props.file.extension
      }`
      document.body.appendChild(a)
      a.click()
      a.remove()
      isLoading.value = false
    })
    .catch(() => {
      console.error('Error while downloading file')
      isLoading.value = false
    })
}
</script>
